import React, { useCallback, useEffect } from "react";
import { Typography } from "@mui/material";
import { useField } from "formik";

import { validateStoreCopyQuantity } from "@/features/campaigns/direct-mail/rrd/utils/rrdValidationHelper";
import RpNumberField from "@/components/muiCustom/textField/RpNumberField";
import {
  getRRDStoreCopyDefaultQuantity,
  isRRDStoreCopyFixedQuantity,
} from "@/features/campaigns/direct-mail/rrd/utils/rrdStoreCopyConfigHelper";

const NumberField = RpNumberField as React.ElementType;

function RRDDirectStoreQntInput({
  name,
  storeCopyToggleName,
  hideWhenStoreCopyIsOff = false,
  storeCopyConfig,
}) {
  const [storeCopyToggleField] = useField(storeCopyToggleName);
  const [storeCopyQntField, , storeCopyQntHelpers] = useField(name);
  const isFixedQuantity = isRRDStoreCopyFixedQuantity(storeCopyConfig);
  const fixedQuantity = getRRDStoreCopyDefaultQuantity(storeCopyConfig);

  useEffect(() => {
    if (!storeCopyToggleField.value) {
      if (storeCopyQntField.value !== "") {
        storeCopyQntHelpers.setValue("");
      }
      return;
    }

    if (isFixedQuantity && storeCopyQntField.value !== fixedQuantity) {
      storeCopyQntHelpers.setValue(fixedQuantity);
    }
  }, [
    fixedQuantity,
    isFixedQuantity,
    storeCopyQntField.value,
    storeCopyQntHelpers,
    storeCopyToggleField.value,
  ]);

  const handleOnStoreCopyQntChange = useCallback(
    (e) => {
      if (isFixedQuantity) {
        return;
      }
      const value = e.target.value;
      const store_copy_qnt = value && !isNaN(value) ? parseInt(value, 10) : "";
      storeCopyQntHelpers.setValue(store_copy_qnt);
    },
    [isFixedQuantity, storeCopyQntHelpers]
  );

  const isQuantityError = validateStoreCopyQuantity({
    storeCopyQnt: storeCopyQntField.value,
    storeCopy: storeCopyToggleField.value,
    storeCopyConfig,
    config: storeCopyConfig,
  });

  if (hideWhenStoreCopyIsOff && !storeCopyToggleField.value) {
    return null;
  }

  return (
    <>
      <Typography variant="body2" gutterBottom fontWeight={600}>
        Quantity
      </Typography>

      <NumberField
        fullWidth
        placeholder="0"
        size="small"
        disabled={!storeCopyToggleField.value || isFixedQuantity}
        readOnly={isFixedQuantity}
        value={storeCopyQntField.value}
        onChange={handleOnStoreCopyQntChange}
        type="text"
        maxValue={storeCopyConfig?.maxQuantity}
        helperText={isQuantityError || ""}
        error={!!isQuantityError}
      />
    </>
  );
}

export default RRDDirectStoreQntInput;
